module.exports = __webpack_public_path__ + "static/media/TomGatesMySchoolProject.abd5dc33.jpeg";